import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { SupplierBill, SupplierBillData, SupplierBillService, ChargeNote, Outcomed, SupplierBillFilter, Justification, SupplierBillId } from '../../services/supplier-bill.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { FiscalDataService } from '../../services/fiscal-data.service';
import { OutcomedBill, OutcomeService, Outcome, OutcomeData } from '../../services/outcome.service';

import { Observable } from 'rxjs/Observable';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { CustomerBillData } from '../../services/customer-bill.service';
import { Utils } from '../../util';
import { PurchaseOrderId, PurchaseOrderService } from '../../services/purchase-order.service';
import { FirestoreService, BatchElement } from '../../services/firestore/firestore.service';
import { update } from 'lodash';

@Component({
  selector: 'app-read-supplier-bill',
  templateUrl: './read-supplier-bill.component.html',
  styleUrls: ['./read-supplier-bill.component.css']
})

export class ReadSupplierBillComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};

  supplierBills:any[] = [];

	data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Folio de factura', name: 'name'},
    {title: 'Proveedor', name: 'supplierName'},
    {title: 'Fecha', name: 'date'},
    {title: 'Total', name: 'money_total', className: 'tdRight thCenter'},
    {title: 'Saldo', name: 'money_residue', className: 'tdRight thCenter'},
    {title: 'Moneda', name: 'currency_and_change'},
    {title: 'Cancelado', name: 'canceled_icon'},
    { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
      { name: 'clear', title: '', styleIcon: 'clear', action: 'onCancel', styleClass: 'btn-floating btn waves-effect red lighten-1' },
			{ name: 'show', title: '', styleIcon: 'open_with', action: 'onShow', styleClass: 'btn-floating btn waves-effect light-blue darken-1' },
      { name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit', styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete', styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
      onCancel: this.openModalCancel.bind(this),
      onShow: this.onShow.bind(this),
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
  };

  receivedAll: boolean = false;

  constructor(
    private service: SupplierBillService,
    private supplierBillData: SupplierBillData,
    private supplierService: CustomerSupplierService,
    private fiscalDataService: FiscalDataService,
    private outcomeService: OutcomeService,
    private outcomeData: OutcomeData,
    private settings: CatalogsSettingsService,
    private billData: CustomerBillData,
    private odcService: PurchaseOrderService,
    private afh: FirestoreService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    this.subs[4] = this.settings.getPayrollSettings('1').subscribe(setting => {
      this.itemsPerPage = setting.tableQuantity;
    });
		this.subs[3] = this.service.getSupplierBillsFifteenDays().subscribe(tempSupplierBills => {
			this.supplierBills = tempSupplierBills.map(supplierBill => {
        this.outcomedBills[supplierBill.id] = new OutcomedBill({...supplierBill});
        supplierBill.name = supplierBill.folio;
        supplierBill.supplierName = supplierBill.supplierObj.name;
        supplierBill.residue = this.outcomedBills[supplierBill.id].residue;
        supplierBill.money_residue = this.money(supplierBill.residue);
        supplierBill.money_total = this.money(supplierBill.total);
        supplierBill.currency_and_change = `${this.billData.currencySelect[supplierBill.currency || 'key0'].code}, ${this.money(supplierBill.change || 1)}`;
        supplierBill.canceled_icon = supplierBill.canceled ? `<i class="small material-icons">done</i>` : `<i class="small material-icons">clear</i>`;
        return supplierBill;
      });
      this.filterBar = new SupplierBillFilter(this.supplierBills, {} );//JSON.parse(localStorage.supplierBillRead || '{}')
      this.applyFilterBar();
    });

    this.readObjs = [];
    this.subs[0] = this.supplierService.getSuppliers().subscribe(suppliers => {
    this.readObjs[0] = {};
      this.rowsRead[0] = suppliers.map(supplier => {
        supplier.id = supplier.id$;
        this.readObjs[0][supplier.id] = {...supplier};
        return supplier;
      });
    });
    this.subs[1] = this.fiscalDataService.getAllFiscalDatas().subscribe(fiscalDatas => {
    this.readObjs[1] = {};
      this.allFiscalRows = fiscalDatas.filter(fiscalData => {
        fiscalData.name = fiscalData.rfc;
        this.readObjs[1][fiscalData.id] = {...fiscalData};
        if(fiscalData.supplierId) return fiscalData;
      });
    });
    this.subs[2] = this.outcomeService.getOutcomes().subscribe(outcomes => {
      this.outcomes = outcomes.reduce((obj, outcome) => {
        outcome.payMethod = this.outcomeData.statusObjects[outcome.payMethod].name;
        obj[outcome.id] = outcome;
        return obj;
      }, {});
    });

	}

  ngOnInit() {
  }
  ngOnDestroy(){
    this.subs.map((sub,index) => {
      this.subs[index].unsubscribe();
    });
  }

  deleteSupplierBill(sid: string) {
    this.service.deleteSupplierBill(sid);
	}

	onCellClick(data: any): any {
		this.service.windowReplace('view', data.row.id);
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.continueReadTo(0);
  }

  onShow(data: any){
    this.selectedSupplierBillId = data.row.id;
    this.openModalShow();
  }

  reasonMsg: string = '';
  cancelingBill: SupplierBillId = null;
  async continueCancel(){
    if(!this.reasonMsg) return toast('Ingrese una justificación.', 2000);
    try{
      let odcsForUpdate: Partial<PurchaseOrderId>[] = [];
      if(!this.cancelingBill.canceled) for(let just of this.cancelingBill.justifications){
        if(!just.purchaseOrderRef || !just.__prForOrderBilled) continue;
        let odc = await this.afh.docWithId<PurchaseOrderId>(`${this.odcService.collection}/${just.purchaseOrderRef}`);
        if(!odc) continue;
        let {id: odcId, prForOrders} = odc;
        for(let prUniqueId of Object.keys(just.__prForOrderBilled)){
          let billedQuantity = just.__prForOrderBilled[prUniqueId] || 0;
          let pr = prForOrders.find(pr => pr.uniqueId == prUniqueId);
          if(!pr || !pr.billedQuantity) continue;
          pr.billedQuantity -= billedQuantity;
        }
        odcsForUpdate.push({id: odcId, prForOrders});
      }
      let batch: BatchElement<'set' | 'update'>[] = [
        {type: 'update', docPath: `${this.service.collection}/${this.cancelingBill.id}`, data: <Partial<SupplierBillId>>{
          canceled: true,
          cancelReasons: [
            ...(this.cancelingBill.cancelReasons || []),
            {datetime: `${Utils.today}, ${Utils.time}`, msg: this.reasonMsg},
          ],
        }},
      ];
      odcsForUpdate.map(({id, prForOrders}) => {
        batch.push({type: 'update', docPath: `${this.odcService.collection}/${id}`, data: {prForOrders}});
      });
      let success = await this.afh.batch(batch);
      if(!success) throw null;
      this.reasonMsg = '';
      this.closeModalCancel();
      toast('Éxito', 2000);
    }catch(error){
      toast('Error inesperado.', 2000);
    }
  }

	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
    if(data.row.canceled) return toast('No se puede editar después de ser cancelado.', 2000);
		this.service.windowReplace('edit', `${data.row.id}/${data.row.fiscalDataObj.id}/${data.row.supplierObj.id}`);
	}

	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
    if((data.row.files || []).length) return toast('Elimine los archivos primero.', 2000);
    if(data.row.justifications.some(({purchaseOrderRef}: Justification) => !!purchaseOrderRef)) return toast('Elimine las justificaciones con orden de compra.', 2000);
		this.deleteSupplierBill(data.row.id);
  }

  ////////////////////////////////////////////////////////////////////FilterBar
  filterBar: SupplierBillFilter = new SupplierBillFilter([],{});
  applyFilterBar(){
    //localStorage.supplierBillRead = this.filterBar.json;

    this.data = this.filterBar.filteredData;
    this.length = this.data.length;
    this.onChangeTable(this.config);
  }
  onChangeDateFilterBar(){
    if(this.filterBar.dateIndex && !this.receivedAll){
      this.subs[3].unsubscribe();
      this.subs[3] = this.service.getSupplierBills().subscribe(tempSupplierBills => {
        this.supplierBills = tempSupplierBills.map(supplierBill => {
          this.outcomedBills[supplierBill.id] = new OutcomedBill({...supplierBill});
          supplierBill.name = supplierBill.folio;
          supplierBill.supplierName = supplierBill.supplierObj.name;
          supplierBill.residue = this.outcomedBills[supplierBill.id].residue;
          supplierBill.money_residue = this.money(supplierBill.residue);
          supplierBill.money_total = this.money(supplierBill.total);
          supplierBill.currency_and_change = `${this.billData.currencySelect[supplierBill.currency || 'key0'].code}, ${this.money(supplierBill.change || 1)}`;
          supplierBill.canceled_icon = supplierBill.canceled ? `<i class="small material-icons">done</i>` : `<i class="small material-icons">clear</i>`;
          return supplierBill;
        });
        this.filterBar = new SupplierBillFilter(this.supplierBills, JSON.parse(this.filterBar.json) );
        this.applyFilterBar();
      });
      this.receivedAll = true;
    }else {
      this.applyFilterBar();
    }
  }
  ////////////////////////////////////////////////////////////////////FilterBar
  
  money = Utils.money;

  /////////////////////////////////////////////////////////////////////////////////////////////////////Outcomes
  modalActionsShow = new EventEmitter<string|MaterializeAction>();
  modalParamsShow = [{dismissible: true}];
  modalActionsCancel = new EventEmitter<string|MaterializeAction>();
  modalParamsCancel = [{dismissible: true}];

  outcomes: any = {};
  outcomedBills: {[billId: string]: OutcomedBill} = {};
  selectedSupplierBillId: string = '';

  outcomeAmount(outcome: Outcome){
    return outcome.bills.find(bill => bill.supplierBillId == this.selectedSupplierBillId).amount;
  }

  openModalShow() {
    this.modalActionsShow.emit({ action: 'modal', params: ['open'] });
  }
  closeModalShow() {
    this.modalActionsShow.emit({ action: 'modal', params: ['close'] });
  }
  openModalCancel({row: bill}: {row: SupplierBillId}) {
    this.cancelingBill = bill;
    this.modalActionsCancel.emit({ action: 'modal', params: ['open'] });
  }
  closeModalCancel() {
    this.modalActionsCancel.emit({ action: 'modal', params: ['close'] });
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////////Outcomes

	//*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.selectedIds[this.currentReadIndex] = data.row.id;
    if(this.readValid) this.continueReadTo(this.currentReadIndex + 1);
  }
  continueReadTo(nextIndex){
    if(nextIndex == this.columnsRead.length){
      this.closeModalRead();
      this.service.windowReplace('add', `${this.selectedIds[1]}/${this.selectedIds[0]}`);
    }else{
      if(nextIndex == 1) this.rowsRead[nextIndex] = this.allFiscalRows.filter(fiscalRow => fiscalRow.supplierId && fiscalRow.supplierId == this.selectedIds[0]);
      this.currentReadIndex = nextIndex;
      this.r_data = this.rowsRead[nextIndex];
      this.r_config = this.r_configs[nextIndex];
      this.r_page = 1;
      this.r_onChangeTable(this.r_config);
      if(nextIndex == 0) this.openModalRead();
    }
  }
  goBackReadTo(prevIndex){
    if(prevIndex < 0){
      this.closeModalRead();
    }else{
      this.selectedIds[prevIndex + 1] = '';
      this.currentReadIndex = prevIndex;
      this.r_data = this.rowsRead[prevIndex];
      this.r_config = this.r_configs[prevIndex];
      this.r_onChangeTable(this.r_config);
    }
  }

  selectedIds: string [] = [];
  readObjs: any[] = [];
  subs: any[] = [];
  readPlaceholders = [ 'un proveedor', 'sus datos fiscales' ]
  get readValid(){ return !!this.selectedIds[this.currentReadIndex] };
  currentReadIndex: number;
  allFiscalRows: any;
  rowsRead = [[], []];
  columnsRead = [
    [//supplier
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ],
    [
      { title: 'RFC', name: 'name', sort: 'asc' },
      { title: 'Razón Social', name: 'businessName' }
    ]
  ]


  r_data:Array<any>;
  r_rows:Array<any> = [];
  r_page:number = 1;
  r_itemsPerPage:number = 5;
  r_maxSize:number = 5;
  r_numPages:number = 1;
  r_length:number = 0;

  
  r_configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));
  r_config = this.r_configs[0];

  /*********** Filter, sort, and pagination */

	r_changePage(page:any, data:Array<any> = this.r_data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  r_changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.r_config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }
    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  r_changeFilter(data:any, config:any):any {
    console.clear();
    console.log(this.columnsRead[this.currentReadIndex])
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.r_config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  r_onChangeTable(config:any, page:any = {page: this.r_page, itemsPerPage: this.r_itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.r_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.r_config.sorting, config.sorting);
    }

    let filteredData = this.r_changeFilter(this.r_data, this.r_config);
    let sortedData = this.r_changeSort(filteredData, this.r_config);
    this.r_rows = page && config.paging ? this.r_changePage(page, sortedData) : sortedData;
    this.r_length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
